export const SERVICES_TYPE = {
    IMPORT: 'IMPORT',
    EXPORT: 'EXPORT',
    TRANSPORT: 'TRANSPORT',
    STORAGE: 'STORAGE',
    IMPORTING_RETURN_GOODS: 'IMPORTING_RETURN_GOODS',
}
